import { Injectable } from "@angular/core";
import {
    Amplifier,
    AmplifierConfigInfo,
    DwdmAmplifierData,
    LosAction,
    MODE_LABEL_MAP,
    PROFILE_LABEL_MAP
} from "../amplifiers-step.model";
import { CircuitPortIdentifierData } from "../../6-osc-management/osc-management-step.model";
import { GenerateAlphabeticIdentifierService } from "@nms-ng2/app/modules/topology/utils/generate-alphabetic-identifier.service";

/**
 * Classe utilitária para step de amplificadores.
 */
@Injectable({
    providedIn: "root"
})
export class AmplifiersUtilsService {

    constructor(private readonly generateIdentifierService: GenerateAlphabeticIdentifierService) {}

    isAmplifierConfigured(value: number | string, limit: number | string, losThreshold: number | string): boolean {
        return Boolean(value) || Boolean(limit) || Boolean(losThreshold);
    }

    loadAmplifiers(amplifiers: Array<Amplifier>, identifiersInUse: string[]): Amplifier[] {
        return amplifiers.map(amplifier => ({
            portIdentifier: amplifier.portIdentifier,
            identifier: this.generateIdentifierService.generate("Amp", identifiersInUse),
            hostname: amplifier.hostname,
            links: amplifier.links,
            portName: amplifier.portName,
            portDescription: amplifier.portDescription,
            profileLabel: PROFILE_LABEL_MAP[amplifier.profile],
            profile: amplifier.profile,
            mode: amplifier.mode,
            modeLabel: MODE_LABEL_MAP[amplifier.mode],
            value: amplifier.value,
            limit: amplifier.limit,
            losAction: (amplifier.losAction) ? LosAction.ENABLED : LosAction.DISABLED,
            losThreshold: amplifier.losThreshold
        }));
    }

    convertAmplifiersToOriginals(amplifiersData: DwdmAmplifierData[], identifiersInUse: string[]): Amplifier[] {
        return amplifiersData.map(response => {
            const portIdentifier: CircuitPortIdentifierData = {
                deviceResourceId: response.deviceResourceId,
                chassisIdentifier: response.chassisNo,
                slotIdentifier: response.slotNo,
                portNo: response.portNo,
                portModelIdentifier: response.portModel
            };

            return {
                identifier: this.generateIdentifierService.generate("Amp", identifiersInUse),
                portIdentifier,
                hostname: response.deviceName,
                portName: response.portName,
                portDescription: response.portDescription,
                profile: response.profile,
                profileLabel: PROFILE_LABEL_MAP[response.profile],
                mode: null,
                modeLabel: null,
                value: null,
                limit: null,
                losThreshold: null,
                losAction: null,
                links: response.links
            }
        });
    }

    convertAmplifierToAmplifierConfigInfo(amplifier: Amplifier): AmplifierConfigInfo {
        const isConfigured = this.isAmplifierConfigured(amplifier.value, amplifier.limit, amplifier.losThreshold);

        return {
            links: amplifier.links,
            profile: amplifier.profile,
            mode: amplifier.mode,
            value: this.convertToNumber(amplifier.value),
            limit: this.convertToNumber(amplifier.limit),
            losThreshold: this.convertToNumber(amplifier.losThreshold),
            losAction: !isConfigured || amplifier.losAction === LosAction.ENABLED
        };
    }

    private convertToNumber(value: string) {
        return value ? Number(value) : null;
    }
}
